// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import ReactDOM from 'react-dom';
import 'normalize.css';
import React from 'react';
import { Provider } from 'mobx-react';
import './globals/scss/globals.scss';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router} from 'react-router-dom';
import PageRouter from './router';
import Header from './components/Main/Header/Header';
import Modal from './components/Util/Modal/Modal';
import stores from './stores';
import Cookies from './util/Cookies';
import Message from './components/Util/Message/Message';
import Alert from './components/Match/Alert/Alert';

const App = () => (
    <Router>
        <Header />
        <PageRouter />
		<Modal/>
        {stores.userStore.user ? <Alert />  : null}
        <Message />
    </Router>
);

async function preLoading() {
    if (Cookies.get('token')) {
        await stores.userStore.setUser();
    }
}

preLoading().then(() => {
    ReactDOM.render((
        <Provider {...stores}>
            {App()}
        </Provider>
    ), document.getElementById('root'));
})


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
